import React from 'react'
import MainNav from '../components/MainNav'

function AdminHome() {
  return <MainNav />
}

export default AdminHome
